import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { Router } from '@angular/router';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.css']
})
export class SignOutComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService,
    private router: Router,
    private globalSrv: GlobalServices) { }

  ngOnInit() {
    this.logout();
  }

  logout() {
    
    this.authenticationService.logout()
      .subscribe((data: ResponseObject) => {
        //this.authenticationService..subscribe(x => this.currentUser = x);;
        this.authenticationService.currentUserSubject.next(null);
        //this.authenticationService.refresh();
        this.globalSrv.goToHome(); 
        //this.router.navigate(['/login']);
        
      });
    //;
  }
}
